// extracted by mini-css-extract-plugin
export default {"redirect_section":"Redirect_redirect_section__xhY0D","error_box":"Redirect_error_box__pnWs-"};